import { render, staticRenderFns } from "./IncreaseSizeRange.vue?vue&type=template&id=3bc61e80"
import script from "./IncreaseSizeRange.vue?vue&type=script&lang=js"
export * from "./IncreaseSizeRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports